
import AnimatedText from '../../../components/base/AnimatedText';

export default function AccessSection() {
  return (
    <section id="access" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <AnimatedText
            text="アクセス"
            className="text-4xl font-bold text-white mb-4"
          />
          <div className="w-24 h-1 bg-blue-500 mx-auto mb-6"></div>
          <AnimatedText
            text="神戸三宮の中心部、アクセス抜群の立地です"
            className="text-xl text-gray-300"
            delay={300}
          />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="bg-gray-900/50 backdrop-blur-sm rounded-lg p-6 border border-blue-500/20">
              <h3 className="text-xl font-bold text-white mb-4 flex items-center">
                <i className="ri-map-pin-line text-blue-500 text-2xl mr-3"></i>
                店舗情報
              </h3>
              <div className="space-y-3 text-gray-300">
                <p><span className="text-blue-400 font-semibold">店名:</span> ATENA（アテナ）</p>
                <p><span className="text-blue-400 font-semibold">住所:</span> 〒650-0004 神戸市中央区中山手通1丁目4-15 コーストテラス東門ビル6階・7階</p>
                <p><span className="text-blue-400 font-semibold">最寄駅:</span> JR三ノ宮駅 徒歩3分</p>
                <p><span className="text-blue-400 font-semibold">電話:</span> 078-954-6898</p>
              </div>
            </div>

            <div className="bg-gray-900/50 backdrop-blur-sm rounded-lg p-6 border border-blue-500/20">
              <h3 className="text-xl font-bold text-white mb-4 flex items-center">
                <i className="ri-train-line text-blue-500 text-2xl mr-3"></i>
                交通アクセス
              </h3>
              <div className="space-y-3 text-gray-300">
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <div>
                    <p className="font-semibold text-white">JR三ノ宮駅</p>
                    <p className="text-sm">東口より徒歩3分</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <div>
                    <p className="font-semibold text-white">阪急神戸三宮駅</p>
                    <p className="text-sm">西口より徒歩5分</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                  <div>
                    <p className="font-semibold text-white">地下鉄三宮駅</p>
                    <p className="text-sm">出口より徒歩4分</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="bg-gray-900/50 backdrop-blur-sm rounded-lg p-4 border border-blue-500/20">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3280.8947!2d135.1955!3d34.6937!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60008ee6b1b4b1b1%3A0x1b1b1b1b1b1b1b1b!2z56We5oi45LiJ5a6u!5e0!3m2!1sja!2sjp!4v1234567890123"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="rounded-lg"
              ></iframe>
            </div>
            
            <div className="absolute -top-4 -right-4 w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center animate-pulse">
              <i className="ri-map-pin-fill text-white text-2xl"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
